import * as React from 'react'
import * as _ from 'lodash'
import './Step.css'

import Graph from './Graph'
import Switch from './Switch'
import Text from './Text'

import { NetworkUser } from 'golgi'
import { standardSCU } from '../util'
import StepProps from './StepProps'
import * as Model from '../types/document'

class Step extends React.Component<StepProps> {

  render() {
    return <NetworkUser debugName="Step" props={this.props} state={this.state} render={() => {
      const {stepC} = this.props

      let particularStep
      const type = stepC.select('stepType').get()
      switch (type) {
      case 'graph':
        particularStep = <Graph {...this.props as StepProps<Model.Graph>} />
        break
      case 'switch':
        particularStep = <Switch {...this.props as StepProps<Model.Switch>} />
        break
      case 'text':
        particularStep = <Text {...this.props as StepProps<Model.Text>} />
        break
      default:
        throw new Error(`Unknown step type "${type}"`)
      }

      return <div className="Step">{particularStep}</div>
    }} />
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/view/Step.tsx